import React, { useState } from 'react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  selectCollectionAccountDetails,
  setAlertWithTitle,
  setCollectionAccountDetails,
  setListStationMasterModalStatus,
  setModPartyMasterHelpStatus,
  setSessionExpired,
} from '../../utility/Redux/modal';

import {
  selectDefultProfileSetting,
  selectPrefix,
  selectreportFromDate,
  selectreportToDate,
  selectStationId,
  selectStationName,
  selectUserType,
  setreportsFromDate,
  setreportsTodate,
  setStationID,
  setStationName,
} from '../../utility/Redux/profile';

import { FormatNumber2 } from '../../utility/component/tools';
import { selectToken } from '../../utility/Redux/security';
import ModListStationMaster from '../../utility/component/modals/modListStationMaster';
import { useRef } from 'react';
import ReactToPrint from 'react-to-print';

import { FromToDate } from '../../utility/component/fromToDate';
import { setReportType } from '../../utility/Redux/refresh';
import GeniusSelectDate from '../../utility/component/selectDate';
import ModPartyMasterHelp from '../../master/partyMasterHelp';
import GeniusTableForReports from '../../utility/component/geniusComponents/geniusTableforReports';
import moment from 'moment';
import IsLocalData from '../../utility/functions/ceckLocalData';
import deleteWholeDatabase from '../../utility/functions/deleteWholeDatabase';
import { CallAPIPromise } from './dashboard/biiling/modal/comman';
import ReportDataTable from '../../utility/component/datagrid/ReportDataTable';
const width = window.innerWidth / 100;
const PartyLedger = () => {
  const dispatch = useDispatch();
  const printRef = useRef();
  const accDetails = useSelector(selectCollectionAccountDetails);
  const { accNumber ,accName} = accDetails;
  const firstDate = useSelector(selectreportFromDate);
  const SecondDate = useSelector(selectreportToDate);
  const userType = useSelector(selectUserType);
  const defaultProfile = useSelector(selectDefultProfileSetting);
  const [list, setList] = useState([]);
console.log(accDetails)
  const [fromDate, setFromDate] = useState(firstDate);
  const [fromDateFocus, setFromDateFocus] = useState(false);
  const [toDate, setToDate] = useState(SecondDate);
  const [toDateFocus, setToDateFocus] = useState(false);

  const columns = React.useMemo(
    () => [
      {
        field: 'VOUCHER_NO',
        accessor: 'VOUCHER_NO',
        // header:'V No.',
        type: 'string',

        cellClassName: 'super-app-theme--cell',
        width: width * 4,
        headerAlign: 'center',
        renderCell: (params) => {
          if (params.value) {
            return <div>{params.value}</div>;
          } else {
            return <div>{''}</div>;
          }
        },

        headerClassName: 'super-app-theme--header',
        renderHeader: (params) => (
          <strong className="text-[#555a66]" style={{ fontSize: 13 }}>
            {'V No.'}
          </strong>
        ),
      },

      {
        field: 'DATE',
        accessor: 'DATE',
        // header:'Date',
        type: 'string',
        cellClassName: 'super-app-theme--cell',
        width: width * 8,
        headerAlign: 'center',
        renderCell: (params) => <div> {params.value} </div>,
        align: 'left',
        headerClassName: 'super-app-theme--header',

        renderHeader: (params) => (
          <strong className="text-[#555a66]" style={{ fontSize: 13 }}>
            {'Date'}
          </strong>
        ),
      },

      {
        field: 'ACCOUNT_NO',
        type: 'number',
        accessor: 'ACCOUNT_NO',
        // header:'Date',
        width: width * 5,
        cellClassName: 'super-app-theme--cell',
        headerAlign: 'center',
        align: 'left',
        headerClassName: 'super-app-theme--header',

        renderHeader: (params) => (
          <strong className="text-[#555a66]" style={{ fontSize: 13 }}>
            {'Acc No.'}
          </strong>
        ),
      },
      {
        field: 'NAME',
        type: 'number',
        accessor: 'NAME',
        // header:'Date',
        cellClassName: 'super-app-theme--cell',
        width: width * 15,
        headerAlign: 'center',
        align: 'left',
        headerClassName: 'super-app-theme--header',

        renderHeader: (params) => (
          <strong className="text-[#555a66]" style={{ fontSize: 13 }}>
            {'Party Name'}
          </strong>
        ),
      },

      {
        field: 'DESC_NAME',
        type: 'string',

        flex: 1,
        accessor: 'DESC_NAME',
        cellClassName: 'super-app-theme--cell',
        headerAlign: 'center',
        headerClassName: 'super-app-theme--header',
        renderHeader: (params) => (
          <strong className="text-[#555a66]" style={{ fontSize: 13 }}>
            {'Description'}
          </strong>
        ),
      },

    

      {
        field: 'DEBIT',
        type: 'string',
        align: 'right',
        accessor: 'DEBIT',
        renderCell: (params) => {
          if (params.value) {
            return <div> {FormatNumber2(params.value)}</div>;
          } else {
            return <div> {''} </div>;
          }
        },
        width: 100,
        headerAlign: 'center',
        cellClassName: 'super-app-theme--cell',

        headerClassName: 'super-app-theme--header',
        renderHeader: (params) => (
          <strong className="text-[#555a66]" style={{ fontSize: 13 }}>
            {'Debit'}
          </strong>
        ),
      },

      {
        field: 'CREDIT',
        type: 'string',
        accessor: 'CREDIT',
        align: 'right',

        width: 100,
        headerAlign: 'center',
        renderCell: (params) => {
          if (params.value) {
            return <div> {FormatNumber2(params.value)}</div>;
          } else {
            return <div> {''} </div>;
          }
        },
        cellClassName: 'super-app-theme--cell',
        headerClassName: 'super-app-theme--header',
        renderHeader: (params) => (
          <strong className="text-[#555a66]" style={{ fontSize: 13 }}>
            {'Credit'}
          </strong>
        ),
      },
  
      {
        field: 'BALANCE',
        type: 'string',
        accessor: 'BALANCE',

        align: 'right',
        width:100,
        headerAlign: 'center',
        cellClassName: 'super-app-theme--cell',
        renderCell: (params) => {
          if (params.value) {
            return <div> {FormatNumber2(params.value)}</div>;
          } else {
            return <div> {''} </div>;
          }
        },

        headerClassName: 'super-app-theme--header',
        renderHeader: (params) => (
          <strong className="text-[#555a66]" style={{ fontSize: 13 }}>
            {'Balance'}
          </strong>
        ),
      },
      {
        field: 'APPROVED',
        type: 'string',
        accessor: 'APPROVED',
        align: 'center',
        width: width * 6,
        headerAlign: 'center',
        renderCell: (params) => {
          return <div>{params.value === 'YES' ? 'YES' : 'NO'}</div>;
        },
        headerClassName: 'super-app-theme--header',
        cellClassName: 'super-app-theme--cell',
        renderHeader: (params) => (
          <strong className="text-[#555a66]" style={{ fontSize: 13 }}>
            {'Approved'}
          </strong>
        ),
      },
    ],
    []
  );
  const columnsMobile = React.useMemo(
    () => [
      {
        field: 'DATE',
        accessor: 'DATE',
        // header:'Date',
        type: 'string',
        cellClassName: 'super-app-theme--cell',
        width: width * 18,
        headerAlign: 'center',
        renderCell: (params) => {
          if (params.value) {
            return <div>{params.value}</div>;
          } else {
            return <div>{''}</div>;
          }
        },
        align: 'left',
        headerClassName: 'super-app-theme--header',

        renderHeader: (params) => (
          <strong className="text-[#555a66]" style={{ fontSize: 13 }}>
            {'Date'}
          </strong>
        ),
      },


      {
        field: 'DEBIT',
        type: 'number',
        width: 60,

        headerAlign: 'center',
        align: 'right',
        headerClassName: 'super-app-theme--header',
        renderCell: (params) => {
          if (params.value) {
            return <div> {FormatNumber2(params.value)} </div>;
          } else {
            return '';
          }
        },
        renderHeader: (params) => <strong>{'Debit'}</strong>,
      },

      {
        field: 'CREDIT',
        type: 'number',
        width: 60,

        headerAlign: 'center',
        align: 'right',
        headerClassName: 'super-app-theme--header',
        renderCell: (params) => {
          if (params.value) {
            return (
              <div className="text-[#023606]">
                {' '}
                {FormatNumber2(params.value)}{' '}
              </div>
            );
          } else {
            return '';
          }
        },
        renderHeader: (params) => <strong>{'Credit'}</strong>,
      },

      {
        field: 'APPROVED',
        type: 'string',
        flex: 1,
        align: 'right',
        renderCell: (params) => {
          if (params.value) {
            return <div> {params.value} </div>;
          } else {
            return '';
          }
        },
        headerAlign: 'center',
        headerClassName: 'super-app-theme--header',
        renderHeader: (params) => <strong>{'Approved'}</strong>,
      },
    ],
    []
  );
  const token = useSelector(selectToken);
  const prefix = useSelector(selectPrefix);

  const station_id = useSelector(selectStationId);


  const getPartyledger = () => {
    deleteWholeDatabase('party_ledger');
    if (accNumber) {
      CallAPIPromise(
        `/api/reports/partyLedger`,
        {
          table_prefix: prefix,
          from_date: window.innerWidth <= 500 ? fromDate : firstDate,
          to_date: window.innerWidth <= 500 ? toDate : SecondDate,
          ACCOUNT_NO: accNumber,
        },
        token,
        dispatch
      )
        .then((e) => {
          if (!e.data.error) {
            let list = [];
          const data = e.data.response;
          let op_bal = 0;

          for (let i = 0; i < data.length; i++) {
            list.push({
              ...data[i],
              id: i + 1,
              OP_BALANCE: op_bal,
              BALANCE: data[i].RUNNING_BALANCE
            });

            op_bal = op_bal + (Number(data[i].DEBIT) - Number(data[i].CREDIT));
          }

            setList(list);
          }
        })
        .catch((e) => {
          console.log(e);

          if (e.response.data.name === 'TokenExpiredError') {
            dispatch(setSessionExpired(true));
          }
        });
    } else {
      dispatch(
        setAlertWithTitle({
          title: 'Alert',
          msg: 'Please Select account first',
        })
      );
    }
  };

  useEffect(() => {
    const elseFunc = () => {
      if (userType === 'MANAGER') {
        dispatch(setStationID(''));
        dispatch(
          setCollectionAccountDetails({
            accName: '',
            accAddress: '',
            accMobile: '',
            accNumber: '',
            stationId: '',
          })
        );
        dispatch(setStationName(''));
      } else {
        dispatch(
          setCollectionAccountDetails({
            accName: '',
            accAddress: '',
            accMobile: '',
            accNumber: '',
            stationId: '',
          })
        );
      }
    };
    const callback = (details, data) => {
      setList(data);

      dispatch(
        setreportsFromDate(moment(details[0].from_date).format('YYYY-MM-DD'))
      );

      dispatch(
        setreportsTodate(moment(details[0].to_date).format('YYYY-MM-DD'))
      );

      dispatch(
        setCollectionAccountDetails({
          accName: details[0].accName,
          accAddress: details[0].accAddress,
          accMobile: details[0].accMobile,
          accNumber: details[0].ACCOUNT_NO,
          stationId: '',
        })
      );
    };
    IsLocalData('party_ledger', callback, elseFunc);

    dispatch(setReportType('partyLedger'));
  }, []);

  const okButton = () => {
    if (userType === 'USER' && accNumber) {
      getPartyledger();
    }
    if (userType === 'MANAGER') {
      if (accNumber) {
        getPartyledger();
      } else {
        dispatch(
          setAlertWithTitle({
            title: 'Alert',
            msg: 'Please select any party first.',
          })
        );
      }
    }
  };

  const readAmount = (value) =>
    Number(String(value || '').replace(/,/g, '').trim()) || 0;

  const footerValue = (column) => {
    if (column.field === 'NAME' || column.field === 'DESC_NAME') {
      return column.field === 'NAME' ? 'TOTAL' : '';
    }
    if (column.field === 'DEBIT') {
      const total = list.reduce((sum, row) => sum + readAmount(row.DEBIT), 0);
      return total ? FormatNumber2(total) : '';
    }
    if (column.field === 'CREDIT') {
      const total = list.reduce((sum, row) => sum + readAmount(row.CREDIT), 0);
      return total ? FormatNumber2(total) : '';
    }
    if (column.field === 'BALANCE') {
      const lastBalance = list[list.length - 1]?.BALANCE;
      return lastBalance ? FormatNumber2(lastBalance) : '';
    }
    return '';
  };

  return (
    <div className="h-full    w-full flex flex-col  p-2 overflow-auto">
      {window.innerWidth <= 500 ? (
        <>
          <div
            className="flex items-center py-3 px-1"
            style={{
              border: '1px solid #b5b3b3',
            }}
          >
            <div className="px-1 font-semibold">From </div>

            <GeniusSelectDate
              date={fromDate}
              setDate={setFromDate}
              dateFocus={fromDateFocus}
              SetDateFocus={setFromDateFocus}
            />
            <div className="px-1 font-semibold">To</div>
            <GeniusSelectDate
              date={toDate}
              setDate={setToDate}
              dateFocus={toDateFocus}
              SetDateFocus={setToDateFocus}
            />
          </div>
          <div
            style={{
              border: '1px solid #b5b3b3',
              borderTop: '0px',
            }}
            className="flex items-center pr-2"
          >
            <div>
              <button
                className="flex items-center rounded-sm ml-2"
                onClick={okButton}
                style={{
                  backgroundColor: '#c1c1c1',
                  paddingLeft: 30,
                  paddingRight: 30,
                  paddingTop: 4,
                  paddingBottom: 4,
                  color: 'black',
                }}
              >
                <div className="flex items-center text-sm">Ok</div>
              </button>
            </div>
          </div>
          <div
            style={{
              border: '1px solid #b5b3b3',
              borderTop: '0px',
            }}
            className="flex w-full"
          >
            <div
              style={
                userType === 'MANAGER'
                  ? {
                      fontSize: 12,
                      width: '100%',
                      color: '#a6a2a2',
                    }
                  : {
                      fontSize: 12,
                      width: '100%',
                      color: '#a6a2a2',
                    }
              }
              className=" flex whitespace-normal  py-3 justify-start items-center  "
            >
              {/* party name 1st part */}
              <div className="flex  h-full items-center px-2 ">
                <div
                  className="flex hover:cursor-pointer h-full items-center w-1/2"
                  onClick={() => dispatch(setModPartyMasterHelpStatus(true))}
                >
                  <div>
                    <i
                      className="bi bi-search"
                      style={{ color: '#f44336', fontSize: 15 }}
                    ></i>
                  </div>

                  <span
                    style={{ fontSize: 12 }}
                    className=" text-[#5c5b5b]  pl-2 flex font-semibold items-center"
                  >
                    Party
                    <span className="pl-1 text-[#5c5b5b] print:hidden font-semibold ">
                      Name
                    </span>
                  </span>
                </div>

                <div
                  style={{
                    border: '1px dotted #a6a2a2 ',
                    borderRadius: '3px',
                  }}
                  className="flex  w-20  pl-2 ml-2 "
                >
                  <input
                    size={'small'}
                    placeholder="All"
                    value={accNumber ? accNumber : 'select'}
                    style={{
                      width: '100%',
                      fontSize: 12,
                      paddingTop: '2px',
                      paddingBottom: '2px',
                      backgroundColor: 'transparent',
                    }}
                    readOnly
                    className=" outline-0 w-30 "
                  />
                </div>

                <div
                  style={{
                    border: '1px dotted #a6a2a2',
                    borderRadius: '3px',
                  }}
                  className="flex w-full h-full ml-2"
                >
                  <div className="flex grow h-full ">
                    <div className="w-full h-full">
                      <div
                        className="w-full h-1/2 print:h-full flex items-center"
                        style={{
                          fontSize: 12,
                          color: 'red',
                        }}
                      >
                        <span className="pl-4 font-semibold ">
                          {accDetails.accName}
                        </span>
                      </div>
                      <div
                        style={{
                          borderTop: '1px dotted #a6a2a2',
                          color: '#f2666f',
                          fontSize: 12,
                        }}
                        className="h-1/2 py-1 flex items-center print:hidden"
                      >
                        <span className="pl-4 font-semibold  ">
                          {accDetails.accAddress + ' '}
                          {accDetails.accMobile}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <FromToDate
          submit={okButton}
          hideStation={true}
          otherButton={
            list[0] && (
              <div className='flex '>
                <ReactToPrint
                  trigger={() => {
                    return (
                      <button
                        style={{
                          borderRadius: '7px',
                          paddingLeft: 30,
                          paddingRight: 30,
                          paddingTop: 4,
                          paddingBottom: 4,
                          backgroundColor: '#bad4f9',
                          color: 'black',
                          marginLeft: 7,
                        }}
                      >
                        <div className="text-sm">Print</div>
                      </button>
                    );
                  }}
                  content={() => printRef.current}
                />


              </div>
            )
          }
          reset={() => {
            if (userType === 'MANAGER') {
              dispatch(setStationID(''));
              dispatch(setStationName(''));
              dispatch(
                setCollectionAccountDetails({
                  accName: '',
                  accAddress: '',
                  accMobile: '',
                  accNumber: '',
                  stationId: '',
                })
              );
            } else {
              dispatch(
                setCollectionAccountDetails({
                  accName: '',
                  accAddress: '',
                  accMobile: '',
                  accNumber: '',
                  stationId: '',
                })
              );
            }
          }}
          partyName={true}
          
        />
      )}
      <div
        style={{
          height: `calc(100% - 100px)`,
        }}
        className="flex flex-col  pt-2 "
      >
        <ReportDataTable
          columns={window.innerWidth <= 500 ? columnsMobile : columns}
          rows={list}
          getRowKey={(row, index) => row.id || index}
          footerValue={footerValue}
          emptyTitle="No records found"
          emptyDescription="Select a party and run the ledger."
          maxHeight="100%"
        />
      </div>
      <div
          ref={printRef}
          style={{
            width: '100%', display: 'block',
            visibility: 'hidden'
          }}
        >
        <GeniusTableForReports
          date={fromDate}
          partyDetails={`${accNumber} - ${accName}`}
          date1={toDate}
          columns={columns}
          data={list}
          title={'Party Ledger'}
        />
      </div>
      <ModListStationMaster
        onRowClick={(p) => {
          dispatch(setStationID(p.row.CODE));
          dispatch(setStationName(p.row.STATION_NAME));
          dispatch(setListStationMasterModalStatus(false));
        }}
      />
      <ModPartyMasterHelp
        SID={station_id}
        onRowClick={(params) => {
          const name = params.row.NAME;
          const mobile = params.row.MOBILE;
          const accNumber = params.row.ACCOUNT_NO;
          const address = params.row.ADDRESS;
          const stationId = params.row.SID;
          const stationName = params.row.SNAME;
          dispatch(
            setCollectionAccountDetails({
              accName: name,
              accAddress: address,
              accMobile: mobile,
              accNumber: accNumber,
              stationId: stationId,
              sName: stationName,
            })
          );
          dispatch(setModPartyMasterHelpStatus(false));
        }}
        onClose={() => {
          dispatch(setModPartyMasterHelpStatus(false));
        }}
      />
    </div>
  );
};

export default PartyLedger;
